import { twMerge } from "tailwind-merge"
import { Counter } from "./Counter"
import { IconChevronLeft, IconChevronRight } from "./Icon"

export const Pagination = ({
  current,
  total,
  setCurrent,
  className,
  showNumbers = true,
  infinite = false,
  noTransition = false,
}: {
  current: number
  total: number
  setCurrent: (page: number) => void
  className?: string
  showNumbers?: boolean
  infinite?: boolean
  noTransition?: boolean
}) => {
  return (
    <div className={twMerge("relative flex justify-end items-center", className)}>
      <div className="flex gap-2 md:gap-1">
        <Counter
          onClick={() => setCurrent(current - 1 >= 0 ? current - 1 : total - 1)}
          disabled={!infinite && current === 0}
          active={!showNumbers}
          noTransition={noTransition}
        >
          <div className="w-[1.2em] h-[1.2em]">
            <IconChevronLeft className="w-full h-full" />
          </div>
        </Counter>

        {showNumbers &&
          [...Array(total)].map((ai, index) => (
            <Counter
              key={index}
              onClick={() => setCurrent(index)}
              active={current === index}
              noTransition={noTransition}
            >
              {index + 1}
            </Counter>
          ))}

        <Counter
          onClick={() => setCurrent((current + 1) % total)}
          disabled={!infinite && current === total - 1}
          active={!showNumbers}
          noTransition={noTransition}
        >
          <div className="w-[1.2em] h-[1.2em]">
            <IconChevronRight className="w-full h-full" />
          </div>
        </Counter>
      </div>
    </div>
  )
}
